export default "__VITE_ASSET__BQ9l8t5Z__"